/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/split'
export default icon
